import { render, staticRenderFns } from "./CoopUser.vue?vue&type=template&id=55d00d38&scoped=true&"
import script from "./CoopUser.vue?vue&type=script&lang=js&"
export * from "./CoopUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d00d38",
  null
  
)

export default component.exports